module.exports = __webpack_public_path__ + "static/img/bg-es.823e2b01.webp";